import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ThemeProvider } from "@emotion/react";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import { persister, queryClient, theme } from "./config";
import LoadingComponent from "./components/LoadingComponent";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.Suspense>
    <ThemeProvider theme={theme}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister }}
      >
        <PersistGate loading={<LoadingComponent />} persistor={persistor}>
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </PersistGate>
      </PersistQueryClientProvider>
    </ThemeProvider>
  </React.Suspense>
);

reportWebVitals();
